module.exports = __webpack_public_path__ + "images/category_lp/brand_samples/pattern_new2/pc/item_05_1e45d495c1d7b519157de795dc47ede2.jpg";